import React, { useEffect, useRef } from 'react';
import hero1 from '../../assets/images/hero1.png';
import hero2 from '../../assets/images/hero2.png';
import hero3 from '../../assets/images/hero3.png';
import hero4 from '../../assets/images/hero4.png';

const heroImages = [hero1, hero2, hero3, hero4];
const ORDER_LINK = 'https://grill-me-crazy-indo-mexican-alice-springs.nextorder.com/';

const Hero: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let targetX = 0;
    let currentX = 0;
    let rafId: number;

    const lerp = (a: number, b: number, t: number) => a + (b - a) * t;

    const animate = () => {
      currentX = lerp(currentX, targetX, 0.08);
      track.style.transform = `translateX(${currentX}px)`;
      rafId = requestAnimationFrame(animate);
    };

    const handleScroll = () => {
      targetX = -(window.scrollY * 0.4);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    rafId = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="overflow-hidden"
      style={{ background: '#FFF2DA' }}
    >
      {/* Main Heading - Centered */}
      <div className="mt-60 text-center mb-6 sm:mb-8 md:mb-12 px-4">
        <h2
          className="font-teko font-medium uppercase tracking-wide leading-none"
          style={{ color: '#0B5026', fontSize: 'clamp(36px, 8vw, 110px)' }}
        >
          NOT YOUR REGULAR RESTAURANT,
        </h2>
        <h3
          className="font-teko font-medium uppercase tracking-wide leading-none"
          style={{ color: '#0B5026', fontSize: 'clamp(36px, 8vw, 110px)' }}
        >
          THIS IS A FLAVOUR REVOLUTION
        </h3>
      </div>

      {/* Scrolling Images */}
      <div className="overflow-hidden w-full">
        <div
          ref={trackRef}
          className="flex items-start"
          style={{ width: 'max-content' }}
        >
          {heroImages.map(
            (src, index) => (
              <div
                key={index}
                className="flex-shrink-0 hero-image-wrapper relative group cursor-pointer p-3 sm:p-4 md:p-5"
              >
                <img
                  src={src}
                  alt={`Hero ${(index % 4) + 1}`}
                  className="w-[180px] h-[200px] sm:w-[260px] sm:h-[290px] md:w-[320px] md:h-[355px] lg:w-[370px] lg:h-[416px] xl:w-[395px] xl:h-[444px] object-cover transition-transform duration-500 group-hover:scale-105"
                  style={{
                    borderTopLeftRadius: '50%',
                    borderTopRightRadius: '50%',
                    borderBottomLeftRadius: '0%',
                    borderBottomRightRadius: '0%',
                  }}
                />
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                  style={{
                    borderTopLeftRadius: '50%',
                    borderTopRightRadius: '50%',
                    background:
                      'linear-gradient(to top, rgba(236,70,28,0.4) 0%, transparent 60%)',
                  }}
                />
              </div>
            )
          )}
        </div>
      </div>

      {/* Paragraph */}
      <div
        className="text-center px-4 sm:px-6 md:px-8"
        style={{ marginTop: '20px', marginBottom: '20px' }}
      >
        <p
          className="font-inter font-normal mx-auto"
          style={{
            color: '#1E1E1E',
            fontSize: 'clamp(16px, 2.5vw, 24px)',
            lineHeight: '1.6',
            maxWidth: '1000px',
          }}
        >
          Grill Me Crazy brings together the fire of Indian street flavours and
          the attitude of Mexican culture into one cinematic dining experience
          filled with flavour, music, cocktails and energy.
        </p>
      </div>

      {/* Reservation Button */}
      <div className="text-center" style={{ marginTop: '30px', marginBottom: '40px' }}>
        <div
          style={{
            boxShadow: '0 4px 0 0 #151515',
            borderRadius: '8px',
            display: 'inline-block',
          }}
        >
          <a
            href={ORDER_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="font-teko font-normal text-black transition-all duration-200 hover:translate-y-[4px] hover:bg-yellow-400"
            style={{
              backgroundColor: '#FFC600',
              fontSize: '22px',
              height: '49.3px',
              width: '172.5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #151515',
              cursor: 'pointer',
              borderRadius: '8px',
              textDecoration: 'none',
            }}
          >
            RESERVATION
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
